import AuthRoutes from './auth';
import EngagementRoutes from './engagement';
import ChatbotForms from './chatbot-forms';
import LandingRoutes from './landing';
import LandingApplicantsRoutes from './landing-applicants';
import LandingLegacyRoutes from './landing-legacy';
import ScalemaRoutes from './scalema';
import JobPostingRoutes from './job-posting';
import OperationsFormRoutes from './ops-form';
import ShareableFormRoutes from './shareable-form';
import LegalRoutes from './legal';
import TrademarksRoutes from './trademarks';
import HelpRoutes from './help';
import CompensationWiki from './compensation';
import BuildYourTeamRoutes from './build-your-team';


const routes = [
    LegalRoutes,
    TrademarksRoutes,
    EngagementRoutes,
    ChatbotForms,
    OperationsFormRoutes,
    ShareableFormRoutes,
    LandingRoutes,
    LandingApplicantsRoutes,
    LandingLegacyRoutes,
    ...ScalemaRoutes,
    JobPostingRoutes,
    ...HelpRoutes,
    ...AuthRoutes,
    CompensationWiki,
    ...BuildYourTeamRoutes
];

export default routes;
